import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Product testimonials — actual RoofClaw clients reacting to their agents.
// Distinct from <Testimonials /> which endorses Adam as a consultant.
// All quotes verified + approved by Adam Sand 2026-05-17.
// Source: projects/roofclaw-seo-2026-05/testimonials/testimonials-block.md

const productTestimonials = [
    {
        quote: "Each day, the gains I see are monumental.",
        name: "Bryan McEvoy",
        role: "OnePath Auto Group",
        agent: "Sophie",
        stars: 5,
    },
    {
        quote: "It is absolutely a game changer and I can't thank you enough.",
        name: "Bryan McEvoy",
        role: "OnePath Auto Group",
        agent: "Sophie",
        stars: 5,
    },
    {
        quote: "Oh my god... I'm in, Adam.",
        name: "Berenice Hardy",
        role: "Divided Sky Roofing & Solar",
        agent: "Marshall",
        stars: 5,
    },
    {
        quote: "My RoofClaw agent took over the work my software stack was doing. I went from about $1,400 a month in software costs down to roughly $400 a month.",
        name: "Andrew Swan",
        role: "Jarhead Construction",
        agent: "Adam Deshell",
        stars: 5,
    },
];

const StarRow = ({ count }) => (
    <div className="flex gap-1 mb-4">
        {Array.from({ length: count }).map((_, i) => (
            <span key={i} className="text-[#7B61FF] text-sm">★</span>
        ))}
    </div>
);

const ProductTestimonials = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.from('.product-testimonial-card', {
                y: 30,
                opacity: 0,
                duration: 0.9,
                stagger: 0.12,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: 'top 80%',
                }
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section ref={containerRef} className="py-24 md:py-32 px-6 md:px-16 bg-[#0A0A14] border-t border-[#7B61FF]/10">
            <div className="max-w-7xl mx-auto">
                <div className="mb-16 max-w-xl">
                    <p className="font-data text-[#7B61FF] text-xs tracking-widest uppercase mb-4">Receipts from the bench</p>
                    <h2 className="text-[#F0EFF4] font-bold text-4xl md:text-5xl tracking-tight">
                        What roofers say{' '}
                        <span className="font-drama text-[#7B61FF]">after their RoofClaw is live.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {productTestimonials.map((t, i) => (
                        <div
                            key={i}
                            className="product-testimonial-card bg-[#18181B] border border-[#7B61FF]/20 rounded-[2rem] p-8 flex flex-col"
                        >
                            <StarRow count={t.stars} />
                            <blockquote className="text-[#F0EFF4] text-lg md:text-xl leading-relaxed mb-6 flex-grow">
                                "{t.quote}"
                            </blockquote>
                            <div className="border-t border-[#7B61FF]/15 pt-4">
                                <p className="text-[#F0EFF4] font-semibold">{t.name}</p>
                                <p className="text-[#F0EFF4]/60 text-sm">{t.role}</p>
                                {t.agent && (
                                    <p className="text-[#7B61FF]/80 text-xs font-data tracking-widest uppercase mt-2">
                                        Agent: {t.agent}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProductTestimonials;
